import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  appBar: {
    backgroundColor: "#FFFFFF",
    zIndex: 99,
  },
  menuButton: {
    marginRight: 12,
  },
  logo: {
    height: "3em",
  },
  user: {
    position: "absolute",
    right: 0,
  },
}));

export default useStyles;
